import { render, staticRenderFns } from "./MobilePwdLessLoginComponent.vue?vue&type=template&id=189a71c0&scoped=true"
import script from "./MobilePwdLessLoginComponent.vue?vue&type=script&lang=js"
export * from "./MobilePwdLessLoginComponent.vue?vue&type=script&lang=js"
import style0 from "./MobilePwdLessLoginComponent.vue?vue&type=style&index=0&id=189a71c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189a71c0",
  null
  
)

export default component.exports